export const qk = {
  // Chats & Tickets
  chats: (filters?: unknown) => filters ? ['chats', filters] as const : ['chats'] as const,
  chat: (id: string) => ['chat', id] as const,
  chatMessages: (id: string, params?: unknown) => params ? ['chatMessages', id, params] as const : ['chatMessages', id] as const,
  ticketStatistics: (agentId?: string, dateRange?: { from: Date; to: Date }) =>
    ['ticketStatistics', agentId, dateRange] as const,

  // Orders
  orders: (filters?: unknown) => ['orders', filters ?? {}] as const,
  order: (id: string) => ['order', id] as const,

  // Couriers
  couriers: () => ['couriers'] as const,
  courier: (id: string) => ['courier', id] as const,
  courierOrders: (courierId: string) => ['courierOrders', courierId] as const,

  // Delivery Operations
  pendingOrders: () => ['deliveryOrders', 'pending'] as const,
  inTransitOrders: () => ['deliveryOrders', 'in-transit'] as const,
  deliveryStats: () => ['deliveryStats'] as const,
}
